<template>
  <section class="checkedTagComponent">
    <ul class="tags-bar">
      <li v-for="(item, index) in checkedTagsOptions" :key="index" class="tag-item">
        <el-tag type="primary" size="medium">{{ item.wordName }}</el-tag>
      </li>
    </ul>
  </section>
</template>

<script>
// import _ from 'lodash'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  model: {
    prop: 'checkedTags',
    event: 'changeTags'
  },
  props: {
    // tagType: {
    //   type: String,
    //   default: 'WORD_MEANS'
    // },
    checkedTags: {
      type: Array,
      default: function () {
        return []
      }
    },
    tagsOptions: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
    checkedTagsOptions () {
      const arr = []
      for (const id of this.checkedTags) {
        for (const item of this.tagsOptions) {
          if (id === item.id) {
            arr.push(item)
            break
          }
        }
      }
      return arr
    }
  },
  watch: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang='scss'>
.checkedTagComponent{
  .tags-bar{
    .tag-item{
      display: inline-block;
    }
  }
}

</style>
